<template src="./TicketCounters.html"></template>

<script>
import { getTicketSummary } from '../../services'

// XAN-193 (adjustments) — ticket counters for the board and for "Mis pendientes".
//
// Read-only on purpose. Making a segment filter the board would be tempting, but "Pendientes"
// spans three statuses and the list endpoint only filters by one, so half the strip would be
// clickable and half not. An affordance that works in some segments and not others is worse than
// none: the filters right below already cover it.
export default {
  name: 'TicketCounters',
  props: {
    // Narrows the counters to one project. Null means "every project I belong to".
    projectId: {
      type: String,
      default: null
    },
    // Narrows them to the tickets assigned to whoever is looking.
    onlyMine: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: true,
    summary: { open: 0, dueToday: 0, overdue: 0, done: 0 }
  }),
  computed: {
    counters () {
      return [
        { key: 'open', label: 'Pendientes', value: this.summary.open },
        { key: 'dueToday', label: 'Vencen hoy', value: this.summary.dueToday },
        { key: 'overdue', label: 'Vencidos', value: this.summary.overdue, alert: this.summary.overdue > 0 },
        { key: 'done', label: 'Completados', value: this.summary.done }
      ]
    }
  },
  watch: {
    projectId () {
      this.fetchSummary()
    }
  },
  created () {
    this.fetchSummary()
  },
  methods: {
    async fetchSummary () {
      this.loading = true
      try {
        const params = {}
        if (this.projectId) params.projectId = this.projectId
        if (this.onlyMine) params.onlyMine = true
        this.summary = await getTicketSummary(params)
      } catch (err) {
        console.error('Error fetching ticket summary:', err)
        this.summary = { open: 0, dueToday: 0, overdue: 0, done: 0 }
      } finally {
        this.loading = false
      }
    },
    // Called by the parent after a ticket changes, so the counters never disagree with the board
    // the user is looking at.
    refresh () {
      this.fetchSummary()
    }
  }
}
</script>

<style lang="scss" src="./TicketCounters.scss" scoped></style>
